import { SocialLoginOption } from "@redotech/redo-model/auth/social-auth";
import { memo } from "react";
import { GoogleSignInButton } from "./google-sign-in-button";
import * as socialLoginOptionsSection from "./social-login-options-section.module.css";

export const SocialLoginOptionsSection = memo(
  function SocialLoginOptionsSection({
    socialLoginOptions,
    nextUrl,
  }: {
    socialLoginOptions: SocialLoginOption[];
    nextUrl?: string;
  }) {
    return (
      <div className={socialLoginOptionsSection.sectionWrap}>
        <div className={socialLoginOptionsSection.dividerWrap}>
          <div className={socialLoginOptionsSection.dividerLine} />
          <div className={socialLoginOptionsSection.dividerText}>Or</div>
        </div>
        <div className={socialLoginOptionsSection.buttonList}>
          {socialLoginOptions?.includes(SocialLoginOption.GOOGLE) && (
            <GoogleSignInButton nextUrl={nextUrl} />
          )}
        </div>
      </div>
    );
  },
);
